export const CHART_RANGE_MINUTES = {
  FIFTEEN_SECONDS: 0.25,
  THIRTY_SECONDS: 0.5,
  MINUTE: 1,
  FIVE_MINUTES: 5,
  FIFTEEN_MINUTES: 15,
  THIRTY_MINUTES: 30,
  HOUR: 60,
  FOUR_HOURS: 240,
  TWELVE_HOURS: 720,
  DAILY: 1440,
  FIVE_DAYS: 7200,
  WEEKLY: 10080,
  FIFTEEN_DAYS: 21600,
  MONTHLY: 43800,
  TWO_MONTHS: 87600,
  EIGHT_MONTHS: 350400,
  YEARLY: 525960,
  TWO_YEARS: 1051920,
  FOUR_YEARS: 2103840,
  SIXTEEN_YEARS: 8415360,
  MAX: 0,
} as const;

/**
 * Time frame for each candle.
 * Matcha API supports 15S, 30S, 1, 5, 15, 30, 60, 240, 720, 1D and 7D.
 */
export const TIME_FRAMES = {
  FIFTEEN_SECONDS: '15S',
  THIRTY_SECONDS: '30S',
  ONE_MINUTE: '1',
  FIVE_MINUTES: '5',
  FIFTEEN_MINUTES: '15',
  THIRTY_MINUTES: '30',
  ONE_HOUR: '60',
  FOUR_HOURS: '240',
  TWELVE_HOURS: '720',
  DAY: '1D',
  WEEK: '1W',
};
